export const TOGGLE_STRINGS = {
  ON: 'true',
  OFF: 'false',
  ENABLE: 'Enable',
  DISABLE: 'Disable'
} as const
